<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="停用-确认停用"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="750px"
        append-to-body>
        <div class="content-wrap p20">
            <p class="text-color-error text-bold mb20">以下产品已无其他启用的绑定客户，您确认要停用吗?</p>
            <el-table
                ref="dataTable"
                :data="dataList"
                tooltip-effect="dark"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :max-height="350"
                stripe
                style="width: 100%;">
                <el-table-column
                    prop="subproject_name"
                    label="推广名称"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="subproject_id"
                    label="推广ID"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="subproject_content"
                    label="推广内容"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="plat_name"
                    label="归属媒体"
                    align="center"
                    min-width="100">
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="danger" @click="confirmResult('1')" class="action-btn mr20" v-matomo="{behaviorCategory: '客户产品管理',name: '批量停用(提交)' }">停用</el-button>
            <el-button type="default" @click="dialogVisible=false" class="action-btn mr20" v-matomo="{behaviorCategory: '客户产品管理',name: '批量停用(取消)' }">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "DisableResultModal",
        props:{},
        data(){
            return {
                dialogVisible:false,
                dataList:[],
            }
        },
        methods:{
            confirmResult(val){
                this.$emit('confirm',val);
                this.dialogVisible = false;
            },
            showModal(dataList){
                this.dataList = dataList;
                this.dialogVisible = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body{
        padding-top: 5px;
    }
</style>
